import React from 'react';
import styled from 'styled-components';
import { getColor } from '../../styling/mixins/colors';
import { breakpoint } from '../../styling/mixins/breakpoints';
import { span } from '../../styling/utils/grid';
import { fontFamilyBold, text } from '../../styling/mixins/typography';
import { SearchItem } from '../../Types/SearchItem';
import ProductTag from '../ProductTags/ProductTag';
import { StyledProductTagWrapperLandscape } from './styles/ProductCardLandscape.styling';
import { translate } from '../../Services/translation';
import LipscoreRating from '../Lipscore/LipscoreRating';

const StyledQuickSearchCard = styled.a`
  display: flex;
  flex-direction: row;
  ${span(2)}
  gap: 0.8rem;
  padding: 1.2rem;
  border: 1px solid ${getColor('grey', 200)};

  ${breakpoint('medium')} {
    ${span(1)}
  }
  ${breakpoint('large')} {
    gap: 1.6rem;
  }

  .image-wrapper {
    display: flex;
    justify-content: center;
  }
  .image {
    aspect-ratio: 1/1;
    object-fit: contain;
    width: 7.2rem;
    height: 7.2rem;
  }
  .text-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .title {
    ${text('medium')}
    ${fontFamilyBold};
  }
  .text {
    ${fontFamilyBold}
    ${text('medium')}
  }
  .brand {
    ${text('medium')}
    color: ${getColor('grey', 500)};
  }
  .price {
    ${text('small')}
    display: flex;
    align-items: center;
    margin-bottom: 0.4rem;
    ${fontFamilyBold}
  }

  .original-price {
    text-decoration: line-through;
    ${fontFamilyBold}
    margin-left: 0.8rem;
    color: ${getColor('grey', 500)};
  }

  .stock {
    ${text('xsmall')}
    color: ${getColor('grey', 600)};
  }

  .star-rating {
    margin-top: 0.8rem;
    margin-bottom: 0.8rem;
  }
`;

const ProductCardQuickSearch = ({ product }: { product: SearchItem }) => {
  return (
    <StyledQuickSearchCard href={product.url}>
      {product.hasImage && (
        <div className="image-wrapper">
          <img className="image" src={product.imageSource} alt={product.name} />
        </div>
      )}
      <div className="text-wrapper">
        {product.tags?.length && product.tags.length > 0 ? (
          <StyledProductTagWrapperLandscape>
            {product.tags.map((tag) => (
              <ProductTag tagSize="large" id={tag.id} key={tag.id}>
                {tag.name}
              </ProductTag>
            ))}
            {product.discountPercantage && (
              <ProductTag id="discount" tagType="campaign" tagSize="large">
                {product.discountPercantage}
              </ProductTag>
            )}
            {product.isNew && (
              <ProductTag id="isNew" tagSize="large">
                {translate('product-tag.is-new')}
              </ProductTag>
            )}
          </StyledProductTagWrapperLandscape>
        ) : (
          <>
            {(product.discountPercantage || product.isNew) && (
              <StyledProductTagWrapperLandscape>
                {product.discountPercantage && (
                  <ProductTag id="discount" tagType="campaign" tagSize="large">
                    {product.discountPercantage}
                  </ProductTag>
                )}
                {product.isNew && (
                  <ProductTag id="isNew" tagSize="large">
                    {translate('product-tag.is-new')}
                  </ProductTag>
                )}
              </StyledProductTagWrapperLandscape>
            )}
          </>
        )}
        <span className="title">
          <b>{product.name}</b>
        </span>
        <span className="text">
          <div className="star-rating">
            {product.lipscoreProduct?.productModel && (
              <LipscoreRating
                productModel={product.lipscoreProduct.productModel}
                readOnly={true}
              />
            )}
          </div>
          {product.price.formattedCampaignPrice ? (
            <div className="price">
              {product.price.formattedCampaignPrice}{' '}
              <span className="original-price">
                {product.price.formattedPrice}
              </span>
            </div>
          ) : (
            product.price.formattedPrice && (
              <div className="price">{product.price.formattedPrice}</div>
            )
          )}
        </span>
        <span className="stock">
          {product.stock?.inStock 
            ? translate('product-listing.is-in-stock')
            : translate('product-listing.is-not-in-stock')}
        </span>
      </div>
    </StyledQuickSearchCard>
  );
};

export default ProductCardQuickSearch;
